module.exports = __webpack_public_path__ + "assets/HKNova-Regular.eot";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Regular.eot
// module id = 107
// module chunks = 0